/* eslint-disable @typescript-eslint/no-explicit-any */
import * as Types from '@whitewater-guide/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ListTagsQueryVariables = Types.Exact<{ [key: string]: never }>;

export type ListTagsQuery = {
  __typename?: 'Query';
  tags: Array<{
    __typename?: 'Tag';
    id: string;
    name: string;
    category: Types.TagCategory;
  }>;
};

export const ListTagsDocument = gql`
  query listTags {
    tags {
      id
      name
      category
    }
  }
`;

/**
 * __useListTagsQuery__
 *
 * To run a query within a React component, call `useListTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListTagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useListTagsQuery(
  baseOptions?: Apollo.QueryHookOptions<ListTagsQuery, ListTagsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListTagsQuery, ListTagsQueryVariables>(
    ListTagsDocument,
    options,
  );
}
export function useListTagsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListTagsQuery,
    ListTagsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListTagsQuery, ListTagsQueryVariables>(
    ListTagsDocument,
    options,
  );
}
export type ListTagsQueryHookResult = ReturnType<typeof useListTagsQuery>;
export type ListTagsLazyQueryHookResult = ReturnType<
  typeof useListTagsLazyQuery
>;
export type ListTagsQueryResult = Apollo.QueryResult<
  ListTagsQuery,
  ListTagsQueryVariables
>;
